import { useEffect, useState } from "react";
import API from "@/lib/api";

const DEFAULT_STATE = {
  step_counter_enabled: false,
  rewards_enabled: false,
  coming_soon_message: "Coming soon — live once our mobile app is published to the App Store & Google Play.",
  loading: true,
};

let _cache = null;
let _cacheAt = 0;
const CACHE_MS = 30_000;

/** Read the wellness-feature flags (step counter, rewards).
 *  Cached across mounts for 30s so we don't hammer the endpoint from
 *  every screen. Callers get { step_counter_enabled, rewards_enabled,
 *  coming_soon_message, loading }. */
export default function useWellnessFeatures() {
  const [state, setState] = useState(() => _cache || DEFAULT_STATE);

  useEffect(() => {
    let alive = true;
    const now = Date.now();
    if (_cache && now - _cacheAt < CACHE_MS) {
      setState(_cache);
      return;
    }
    (async () => {
      try {
        const { data } = await API.get("/system/wellness-status");
        _cache = { ...data, loading: false };
        _cacheAt = Date.now();
        if (alive) setState(_cache);
      } catch {
        if (alive) setState({ ...DEFAULT_STATE, loading: false });
      }
    })();
    return () => { alive = false; };
  }, []);

  return state;
}
